import {Container, Title, Space, Flex, useMantineTheme} from "@mantine/core";
import {useEffect, useState} from "react";
import ShellLayout from "../../../components/layoutComponents/shellLayout/ShellLayout";
import {useLazyGetMarketplaceStatusQuery, useRefreshMarketplaceFeedsMutation} from "../../../services/MarketplaceService";
import MarketplaceStatusTable from "../../../components/pageComponents/marketplaceStatus/MarketplaceStatusTable";
import MarketplaceFilters, {FilterValues} from "../../../components/pageComponents/marketplaceStatus/MarketplaceFilters";
import MarketplaceStats from "../../../components/pageComponents/marketplaceStatus/MarketplaceStats";
import ConnectionStatus from "../../../components/layoutComponents/connectionStatus/ConnectionStatus";

/**
 * Pagina principale per il monitoraggio degli articoli sui marketplace.
 * 
 * Visualizza per ogni articolo lo stato su tutti i marketplace configurati:
 * - Abilitazione in backoffice
 * - Presenza nel feed esportato
 * - Pubblicazione sul marketplace
 * - Vendibilità
 * 
 * Include funzionalità di:
 * - Filtri avanzati (marketplace, stato, ricerca)
 * - Statistiche aggregate
 * - Export CSV
 * - Refresh dati e feed
 */

const MarketplaceStatus = () => {
    const theme = useMantineTheme();
    
    // Hook per recuperare i dati marketplace
    const [getMarketplaceStatus, {data, isFetching}] = useLazyGetMarketplaceStatusQuery();
    const [refreshFeeds, {isLoading: refreshing}] = useRefreshMarketplaceFeedsMutation();
    
    // Stato filtri
    const [filters, setFilters] = useState<FilterValues>({
        marketplaces: [],
        statuses: [],
        categories: [],
        grades: [],
        availability: undefined,
        search: '',
        showDisabled: false,
        warnings: []
    });

    // Carica i dati all'avvio della pagina
    useEffect(() => {
        getMarketplaceStatus(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * Gestisce il refresh dei dati e dei feed
     */
    const handleRefresh = () => {
        getMarketplaceStatus(true);
        refreshFeeds();
    };

    return (
        <ShellLayout
            Body={
                <>
                    <Space h="lg"/>
                    <Container size="95%">
                        <Flex justify="space-between" align="center" mb="xl">
                            <Title order={1} fw={500} c={theme.colors.textBlack?.[0] || 'black'}>
                                Monitoraggio Marketplace
                            </Title>
                            <ConnectionStatus/>
                        </Flex>

                        <MarketplaceStats data={data}/>

                        <MarketplaceFilters
                            filters={filters}
                            setFilters={setFilters}
                            onRefresh={handleRefresh}
                            refreshing={refreshing || isFetching}
                            data={data}
                        />

                        <MarketplaceStatusTable
                            data={data}
                            loading={isFetching}
                            filters={filters}
                        />
                    </Container>
                </>
            }
        />
    );
};

export default MarketplaceStatus;
